import { render, staticRenderFns } from "./pos-contact-details.vue?vue&type=template&id=31e93157&scoped=true&"
import script from "./pos-contact-details.vue?vue&type=script&lang=ts&"
export * from "./pos-contact-details.vue?vue&type=script&lang=ts&"
import style0 from "./pos-contact-details.vue?vue&type=style&index=0&id=31e93157&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e93157",
  null
  
)

export default component.exports